import { render, staticRenderFns } from "./transactionData.vue?vue&type=template&id=06bf9986"
import script from "./transactionData.vue?vue&type=script&lang=js"
export * from "./transactionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports